<template>
  <div
    v-if="
      blocked ||
        deactivated ||
        (basicPlayer && !senderIsClubCoach) ||
        (senderIsBasicPlayer && !receiverIsClubCoach)
    "
  ></div>
  <div class="convo-panel-footer" v-else>
    <div class="footer-hint">
      Use Shift + enter to start a new line
      <a v-if="this.onlyPlayer()" @click="insertProfileLink"
        >Insert profile link</a
      >
    </div>
    <div class="footer-message-send-wrapper">
      <div class="send-message-input">
        <TextArea
          placeholder="Type a message..."
          @change="event => handleMessageChange(event.target.value)"
          :value="message"
          @keydown.enter="handleEnterPress"
          :disabled="blocked || deactivated || basicPlayer"
          auto-size
          ref="messageInput"
          v-bind:style="{height: TextAreaHeight+'px !important'}"
        />
      </div>
      <div class="send-icon" @click="handleMessageSend">
        <img src="@/assets/icons/send.svg" alt="send message" />
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "ant-design-vue";

export default {
  name: "ConvoFooter",
  components: {
    TextArea: Input.TextArea
  },
  data() {
    return {
      message: "",
      TextAreaHeight:""
    };
  },
  props: {
    blocked: {
      type: Boolean,
      default: false
    },
    deactivated: {
      type: Boolean,
      default: false
    },
    basicPlayer: {
      type: Boolean,
      default: false
    },
    senderIsBasicPlayer: {
      type: Boolean,
      default: false
    },
    receiverIsClubCoach: {
      type: Boolean,
      default: false
    },
    senderIsClubCoach: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleMessageChange(value) {
      this.message = value.trim();
      this.$emit("type", value);
      if(this.$refs.messageInput.$el.value.length > 150){
        this.TextAreaHeight = 70;
      }else{
        this.TextAreaHeight = 40;
      }
    },
    handleMessageSend() {
      if (!this.message.trim()) return;
      this.$emit("send", this.message);
      this.message = "";
      this.$refs.messageInput.$el.value = "";
    },
    handleEnterPress(event) {
      if (event.shiftKey) {
        return;
      } else {
        this.handleMessageSend();
      }
    },
    insertProfileLink() {
      this.message = `${this.message} ${window.location.origin}/athlete/${this.$route.params.profileId}/fromlink `;
    }
  }
};
</script>

<style lang="scss">
@keyframes zoominout {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.3, 1.3);
  }
  100% {
    transform: scale(1, 1);
  }
}
.convo-panel-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px 20px;
  background: #f0f0f0;
  justify-content: space-between;
  align-items: center;
  .footer-hint {
    width: 100%;
    font-size: 11px;
    color: #6b6b6b;
    display: flex;
    justify-content: space-between;
    padding-right: 50px;
  }
  .footer-message-send-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .send-message-input {
    width: 100%;
    padding-right: 20px;
    textarea {
      padding: 9px 12px 11px;
    }
  }
  .send-icon {
    cursor: pointer;
    width: 28px;
    transition: all 0.2s linear;
    &:hover {
      animation: zoominout 0.5s 1;
    }
  }
}
</style>
